module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "about__container"
  }, [_c('h1', {
    staticClass: "about__title"
  }, [_vm._v("À propos")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ui-button-to-home', {
    attrs: {
      "goToFilters": false
    }
  })], 1), _vm._v(" "), _c('ui-footer', {
    ref: "uiFooter"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about__credit about__texts"
  }, [_c('h2', {
    staticClass: "about__subtitle"
  }, [_vm._v("Crédits")]), _vm._v(" "), _c('p', {
    staticClass: "about__production about__text"
  }, [_c('span', {
    staticClass: "about__text--bold"
  }, [_vm._v("Production : ")]), _vm._v("Réunion des musées nationaux - Grand Palais")]), _vm._v(" "), _c('p', {
    staticClass: "about__project-management about__text"
  }, [_c('span', {
    staticClass: "about__text--bold"
  }, [_vm._v("Gestion de projet : ")]), _vm._v("Léa Ducré - UPIAN")]), _vm._v(" "), _c('p', {
    staticClass: "about__project-management about__text"
  }, [_c('span', {
    staticClass: "about__text--bold"
  }, [_vm._v("Conception, direction artistique : ")]), _vm._v("Karim Moreau - UPIAN")]), _vm._v(" "), _c('p', {
    staticClass: "about__project-management about__text"
  }, [_c('span', {
    staticClass: "about__text--bold"
  }, [_vm._v("Code créatif & développement : ")]), _vm._v("Emmanuel Durgoni, Geoffrey Legenty - UPIAN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about__data-collect about__texts"
  }, [_c('h2', {
    staticClass: "about__subtitle"
  }, [_vm._v("Protection des données")]), _vm._v(" "), _c('p', {
    staticClass: "about__text"
  }, [_vm._v("Aucune donnée personnelle afférente à l'utilisation du site n'est collectée\n        de façon permanente ni transmise à des tiers.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about__contact about__texts"
  }, [_c('h2', {
    staticClass: "about__subtitle"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('p', {
    staticClass: "about__text about__text--mail"
  }, [_vm._v("webmaster@rmngp.fr")])])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-77e0d33a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/index.vue
 ** module id = 754
 ** module chunks = 2
 **/